export type Language = 'de' | 'en' | 'ja' | 'fr' | 'es' | 'it' | 'nl' | 'pl' | 'lv' | 'et' | 'lt' | 'fi' | 'sv' | 'no' | 'da' | 'sl' | 'ro' | 'hu' | 'cs' | 'sk' | 'pt' | 'el' | 'bg' | 'hr';

// Import individual language files
import { en } from './lang/en';
import { fr } from './lang/fr';
import { es } from './lang/es';
import { it } from './lang/it';
import { nl } from './lang/nl';
import { pl } from './lang/pl';
import { lv } from './lang/lv';
import { et } from './lang/et';
import { lt } from './lang/lt';
import { fi } from './lang/fi';
import { sv } from './lang/sv';
import { no } from './lang/no';
import { da } from './lang/da';
import { sl } from './lang/sl';
import { ro } from './lang/ro';
import { hu } from './lang/hu';
import { cs } from './lang/cs';
import { sk } from './lang/sk';
import { pt } from './lang/pt';
import { el } from './lang/el';
import { bg } from './lang/bg';
import { hr } from './lang/hr';

// Import Translation type
import { Translation } from './types';
export type { Translation };

// Import German and Japanese translations from the main translations object
import { de } from './de';
import { ja } from './ja';

// Combine all translations
export const translations: Record<Language, Translation> = {
  de,
  en,
  ja,
  fr,
  es,
  it,
  nl,
  pl,
  lv,
  et,
  lt,
  fi,
  sv,
  no,
  da,
  sl,
  ro,
  hu,
  cs,
  sk,
  pt,
  el,
  bg,
  hr,
};

export const getTranslation = (language: Language): Translation => {
  return translations[language] || translations.ja;
};